module.exports = __webpack_public_path__ + "img/20191031163302360截图20191031152236787.33a0f955.jpg";